module.exports = __webpack_public_path__ + "static/media/rw-logo-with-text-small.e3e64834.svg";